import React from "react";
import { useEditCustomColumnModal } from "../../utils/useEditCustomColumnModal";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { ArrowBack } from "@material-ui/icons";
import { CustomColumnFormFields } from "../../../CustomColumnFormFields/CustomColumnFormFields";
import { DeleteColumnModal } from "../../../DeleteColumnModal/DeleteColumnModal";
import { useDeleteColumnModal } from "../../../DeleteColumnModal/utils/useDeleteColumnModal";

export const EditCustomColumnModalBase = ({
  handleSubmit,
  sectionName,
  submitting,
}) => {
  const { isEditCustomColumnModalOpen, closeEditCustomColumnModal } =
    useEditCustomColumnModal();
  const column_name = "New status column";

  const { openDeleteCustomColumnModal, isDeleteCustomColumnModalOpen } =
    useDeleteColumnModal();
  return (
    <>
      <ExlyModal
        title={
          <div className="d-flex align-items-center">
            <ArrowBack
              className="tw-w-6 tw-h-6 tw-text-[#1c1b1f] tw-mr-2 tw-cursor-pointer"
              onClick={closeEditCustomColumnModal}
            />
            {`Edit ${column_name}`}
          </div>
        }
        primaryBtnText="Save changes"
        onPrimaryBtnClick={handleSubmit}
        primaryBtnProps={{
          loading: submitting,
          disabled: submitting,
        }}
        secondaryBtnText="Delete Column"
        onSecondaryBtnClick={openDeleteCustomColumnModal}
        open={isEditCustomColumnModalOpen && !isDeleteCustomColumnModalOpen}
        onClose={closeEditCustomColumnModal}
        padded={false}
        modal_props={{
          modalPaperClassName: "tw-w-[555px]",
          secondaryBtnClassName:
            "!tw-text-[#c70900] !tw-min-w-auto !tw-bg-transparent hover:tw-bg-transparent",
          footerClassName: "!tw-justify-between",
          keepMounted: true,
        }}
        mobile_modal_props={{
          secondaryAction: {
            label: "Delete Column",
            onClick: openDeleteCustomColumnModal,
            className:
              "!tw-text-[#c70900] !tw-min-w-auto !tw-bg-transparent hover:tw-bg-transparent",
          },
        }}
      >
        <CustomColumnFormFields isEdit={true} />
      </ExlyModal>
      {isDeleteCustomColumnModalOpen && (
        <DeleteColumnModal sectionName={sectionName} />
      )}
    </>
  );
};
